// Daily Brief Data Actions
export const FETCH_DAILY_BRIEF_START = 'FETCH_DAILY_BRIEF_START';
export const FETCH_DAILY_BRIEF_SUCCESS = 'FETCH_DAILY_BRIEF_SUCCESS';
export const FETCH_DAILY_BRIEF_ERROR = 'FETCH_DAILY_BRIEF_ERROR';

export const LOAD_MORE_DAILY_BRIEF_START = 'LOAD_MORE_DAILY_BRIEF_START';
export const LOAD_MORE_DAILY_BRIEF_SUCCESS = 'LOAD_MORE_DAILY_BRIEF_SUCCESS';
export const LOAD_MORE_DAILY_BRIEF_ERROR = 'LOAD_MORE_DAILY_BRIEF_ERROR';

export const RESET_DAILY_BRIEF_DATA = 'RESET_DAILY_BRIEF_DATA';

export const FETCH_SETTINGS_START = 'FETCH_SETTINGS_START';
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_ERROR = 'FETCH_SETTINGS_ERROR';

export const UPDATE_SETTINGS_START = 'UPDATE_SETTINGS_START';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_ERROR = 'UPDATE_SETTINGS_ERROR';
export const UPDATE_SETTINGS_OPTIMISTIC = 'UPDATE_SETTINGS_OPTIMISTIC';

export const FETCH_FILTER_SELECTIONS_START = 'FETCH_FILTER_SELECTIONS_START';
export const FETCH_FILTER_SELECTIONS_SUCCESS = 'FETCH_FILTER_SELECTIONS_SUCCESS';
export const FETCH_FILTER_SELECTIONS_ERROR = 'FETCH_FILTER_SELECTIONS_ERROR';

// Daily Brief UI Actions
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const SET_FILTER_IDS = 'SET_FILTER_IDS';
export const SET_SORT_BY = 'SET_SORT_BY';
export const SET_SORT_DIRECTION = 'SET_SORT_DIRECTION';
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const RESET_FILTERS = 'RESET_FILTERS';
